module.exports = __webpack_public_path__ + "static/2-db72bde3c546c7b81c02529126ddbf3e.jpg";